import React, { useCallback, useEffect } from "react";
import { message, Modal } from "antd";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../../../application/store";
import I18n from "../../../../../../i18n";
import {
  deleteAddress,
  loadAddresses,
} from "../../../../../../../application/addresses";

type DeleteAddressModalProps = {
  visible: boolean;
  onClose: () => void;
  addressId: number;
};

const DeleteAddressModal: React.FC<DeleteAddressModalProps> = ({
  onClose,
  visible,
  addressId,
}) => {
  const dispatch = useAppDispatch();
  const { loadingDeleteAddress } = useAppSelector((state) => state.addresses);

  const submit = async () => dispatch(deleteAddress(addressId));

  const stableDispatch = useCallback(dispatch, []);
  const stableOnClose = useCallback(onClose, []);
  useEffect(() => {
    if (loadingDeleteAddress === "failed") {
      message.error(I18n.general.networkError);
    } else if (loadingDeleteAddress === "succeeded") {
      stableDispatch(loadAddresses());
      stableOnClose();
    }
  }, [loadingDeleteAddress, stableDispatch, stableOnClose]);

  const isLoading = loadingDeleteAddress === "pending";
  return (
    <Modal
      title={I18n.profile.deleteAddressModal.title}
      visible={visible}
      onCancel={
        isLoading
          ? undefined
          : () => {
              onClose();
            }
      }
      onOk={submit}
      closable={!isLoading}
      maskClosable={!isLoading}
      confirmLoading={isLoading}
      width={335}
    >
      {I18n.profile.deleteAddressModal.description}
    </Modal>
  );
};

export default DeleteAddressModal;
